export default __webpack_public_path__ + "static/media/mvaPoster.ea35a222.jpg";